const mediaItems = [
  {
    title: '流浪地球3：人类命运新篇章',
    meta: '科幻巨制 · 4K超清',
    views: '856万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20poster%20style%20featuring%20a%20massive%20futuristic%20space%20station%20with%20warm%20golden%20and%20deep%20crimson%20lighting%2C%20abstract%20film%20scene%20atmosphere%2C%20luxurious%20velvet%20texture%2C%20elegant%20theater%20vibe%2C%20no%20text%2C%20cinematic%20composition%2C%20rich%20contrast&width=600&height=900&seq=media-01&orientation=portrait',
  },
  {
    title: '封神第二部：战火西岐',
    meta: '史诗奇幻 · 1080P',
    views: '723万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20poster%20style%20with%20ancient%20Chinese%20mythological%20warriors%20silhouette%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20abstract%20film%20scene%20atmosphere%2C%20elegant%20theater%20vibe%2C%20no%20text%2C%20cinematic%20composition&width=600&height=900&seq=media-02&orientation=portrait',
  },
  {
    title: '奥本海默：原子弹之父',
    meta: '历史传记 · 4K超清',
    views: '691万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20poster%20style%20with%20mushroom%20cloud%20silhouette%20and%20intense%20orange%20fire%20glow%2C%20dramatic%20golden%20lighting%2C%20abstract%20film%20scene%2C%20elegant%20theater%20vibe%2C%20no%20text%2C%20cinematic%20rich%20contrast&width=600&height=900&seq=media-03&orientation=portrait',
  },
  {
    title: '孤注一掷：反诈风云',
    meta: '犯罪剧情 · 1080P',
    views: '1,245万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20poster%20style%20with%20mysterious%20urban%20night%20neon%20red%20glow%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20abstract%20film%20scene%2C%20elegant%20theater%20vibe%2C%20no%20text%2C%20cinematic%20composition&width=600&height=900&seq=media-04&orientation=portrait',
  },
  {
    title: '海王2：失落的王国',
    meta: '超级英雄 · 4K超清',
    views: '538万',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20poster%20style%20with%20deep%20ocean%20underwater%20kingdom%20silhouette%20and%20aqua%20golden%20light%2C%20dramatic%20lighting%2C%20abstract%20film%20scene%2C%20elegant%20theater%20vibe%2C%20no%20text%2C%20cinematic%20rich%20contrast&width=600&height=900&seq=media-05&orientation=portrait',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">精彩推荐</h2>
          <p className="text-foreground-500 text-sm mt-2">本周最受欢迎的影片精选</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all cursor-pointer"
            >
              <div className="relative aspect-[2/3] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
                <div className="absolute top-2 right-2 px-2 py-1 bg-background-50/80 backdrop-blur-sm rounded text-[10px] text-foreground-300">
                  4K
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-500/90 rounded-full">
                    <i className="ri-play-fill text-background-950 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <h3 className="font-heading text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between mt-1.5">
                  <span className="text-foreground-600 text-xs">{item.views} 次播放</span>
                  <span className="text-primary-400 text-xs flex items-center gap-0.5">
                    <i className="ri-star-fill text-[10px]"></i> 9+
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}